module.exports = __webpack_public_path__ + "img/home1_yinliu_logo.b26e0adc.png";